const cookiePopupButtonSelector = '.cc-nb-main-container .cc-nb-buttons-container > button, .termsfeed-com---pc-overlay > .cc-cp-foot-button > button, .termsfeed-com---pc-overlay .cc-cp-foot-button > button, .termsfeed-com---pc-dialog .cc-cp-foot-button > button, .cc-pc-container .cc-cp-foot-save';

function initCookiePopupButtons() {
  const buttons = document.querySelectorAll(cookiePopupButtonSelector);
  if (!buttons.length) return false;

  buttons.forEach((button) => {
    if (button.dataset.cookieBtnReady === '1') return;

    button.dataset.cookieBtnReady = '1';
    button.classList.remove('btn', 'pink');
    button.classList.add('split-btn', 'medium-size');

    const existingText = button.querySelector('.split-btn__text, .btn__text');
    const buttonText = (existingText ? existingText.textContent : button.textContent).trim();

    button.textContent = '';

    const textBlock = document.createElement('div');
    textBlock.className = 'split-btn__text';
    textBlock.textContent = buttonText;

    const iconBlock = document.createElement('div');
    iconBlock.className = 'split-btn__icon';

    const icon = document.createElement('i');
    icon.className = 'icon-arrow';
    iconBlock.appendChild(icon);

    button.append(textBlock, iconBlock);
  });

  return true;
}

function hasCookiePopupButtons(node) {
  if (!(node instanceof Element)) return false;
  if (node.matches(cookiePopupButtonSelector)) return true;
  return !!node.querySelector(cookiePopupButtonSelector);
}

let isCookieButtonsInitScheduled = false;
function scheduleCookiePopupButtonsInit() {
  if (isCookieButtonsInitScheduled) return;
  isCookieButtonsInitScheduled = true;

  requestAnimationFrame(() => {
    isCookieButtonsInitScheduled = false;
    initCookiePopupButtons();
  });
}

initCookiePopupButtons();

const cookiePopupObserver = new MutationObserver((mutations) => {
  for (let i = 0; i < mutations.length; i += 1) {
    const mutation = mutations[i];
    if (!mutation.addedNodes || !mutation.addedNodes.length) continue;

    for (let j = 0; j < mutation.addedNodes.length; j += 1) {
      if (hasCookiePopupButtons(mutation.addedNodes[j])) {
        scheduleCookiePopupButtonsInit();
        return;
      }
    }
  }
});

cookiePopupObserver.observe(document.documentElement, { childList: true, subtree: true });
